import React from 'react';

import { Router } from '@reach/router';

import SignOut from '../features/auth/SignOut';
import MemberInvoicesPage from '../features/finance/invoices/MemberInvoicesPage';
import PurchaseInvoicePage from '../features/members/invoices/PurchaseInvoicePage';
import SalesInvoicePage from '../features/members/invoices/SalesInvoicePage';

const Goodbye = () => {
    return <div style={{ padding: '2rem'}}>
        <h1>Sorry - access to TiCiT 1 is now restricted</h1>
        <h3>Please contact an administrator if you need access</h3>
        <h3>If you're looking for TiCiT 2 it's <a href="https://live-ticit2.web.app">here</a></h3>
        <h3>If you need access to your TIC 1 invoices click <a href="/finance/purchase_invoices">here</a></h3>
        <SignOut />
    </div>
}

const SunsetRoutes = () => {
    return (
        <Router>
            <Goodbye default path="/" />
            <MemberInvoicesPage path="/finance/purchase_invoices" />
            <PurchaseInvoicePage path="/organizations/:organizationId/purchase_invoices/:invoiceId"  />
            <SalesInvoicePage path="/organizations/:organizationId/sales_invoices/:invoiceId"  />
        </Router>
    );
};

export default SunsetRoutes;